
import { Col } from 'react-bootstrap'
import { TopRevenueClients } from '../../../financialDashboard/Modules/TopRevenueClients'
import { CEOSalesFunnel } from './CEOSalesFunnel'
import { CEOCacLtvGraph } from './CEOCacLtvGraph'
import { GetRequest } from '../../../../../Utils/hooks/ApiHandler'
import { useGetEssentials } from '../../../../../Utils/hooks/useGetEssentials'
import { useEffect, useState } from 'react'

export const CEOFunnelAndClients = () => {
    const { customerId, headers, extras } = useGetEssentials()
    const [funnelData, setFunnelData] = useState(null)
    const [topClients, setTopClients] = useState(null)

    const fetchData = async () => {
        try {
            const res = await GetRequest(`dashboard/sales_funnel_top_revenue/${customerId}`, { headers }, extras)
            console.log('res', res)
            if (res.status === 'fail' || res.success === false) {
                setFunnelData(null)
                setTopClients(null)
                return
            }
            // first we need to calculate the win rate based on the qualified or won leads this month compared to last month
            const thisMonthLeads = res.data?.total_won_leads;
            const lastMonthWonLeads = res.data?.total_won_leads_last_month;
            const winRate = lastMonthWonLeads > 0 ? (thisMonthLeads / lastMonthWonLeads) * 100 : 0;
            setFunnelData({
                newLeads: res.data?.new_leads,
                winRate: winRate.toFixed(2),
                qualifiedLeads: res.data?.total_won_leads,
            })
            setTopClients(res.data?.top_revenue_client)
        } catch (error) {
            return
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            <CEOSalesFunnel data={funnelData} />
            <Col lg={4} >
                <TopRevenueClients data={topClients} />
            </Col>
            <CEOCacLtvGraph />
        </>
    )
}
